export function stepCollection() {
	return {
		'auth-dashboard': [
			// 대쉬보드
			{
				id: 'banner',
				title: this.$t('tutorial.dashboard.step6_title'),
				text: this.$t('tutorial.dashboard.step6_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#banner',
					on: 'top',
				},
				canClickTarget: true,
			},
			{
				id: 'popularAssets',
				title: this.$t('tutorial.dashboard.step1_title'),
				text: this.$t('tutorial.dashboard.step1_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#popularAssets',
					on: 'bottom',
				},
			},
			{
				id: 'send',
				title: this.$t('tutorial.dashboard.step2_title'),
				text: this.$t('tutorial.dashboard.step2_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#send',
					on: 'top-start',
				},
			},
			{
				id: 'request',
				title: this.$t('tutorial.dashboard.step3_title'),
				text: this.$t('tutorial.dashboard.step3_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#request',
					on: 'bottom',
				},
			},
			{
				id: 'history',
				title: this.$t('tutorial.dashboard.step4_title'),
				text: this.$t('tutorial.dashboard.step4_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#history',
					on: 'bottom-end',
				},
			},
			{
				id: 'bookmark',
				title: this.$t('tutorial.dashboard.step5_title'),
				text: this.$t('tutorial.dashboard.step5_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#bookmark',
					on: 'bottom',
				},
			},
		],
		'pay-payment': [
			// 자산보내기
			{
				id: 'selectAsset',
				title: this.$t('tutorial.payment.step1_title'),
				text: this.$t('tutorial.payment.step1_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectAsset',
					on: 'bottom-start',
				},
				classes: 'top_left',
			},
			{
				id: 'selectWay',
				title: this.$t('tutorial.payment.step2_title'),
				text: this.$t('tutorial.payment.step2_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectWay',
					on: 'bottom-start',
				},
			},
			{
				id: 'selectWay',
				title: this.$t('tutorial.payment.step3_title'),
				text: this.$t('tutorial.payment.step3_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectWay',
					on: 'bottom-start',
				},
			},
			{
				id: 'selectWay',
				title: this.$t('tutorial.payment.step4_title'),
				text: this.$t('tutorial.payment.step4_text'),

				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectWay',
					on: 'bottom-start',
				},
			},
			{
				id: 'selectWay',
				title: this.$t('tutorial.payment.step5_title'),
				text: this.$t('tutorial.payment.step5_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectWay',
					on: 'bottom-start',
				},
			},
		],
		'pay-deposit': [
			// 자산 요청하기
			{
				id: 'selectAsset',
				title: this.$t('tutorial.deposit.step1_title'),
				text: this.$t('tutorial.deposit.step1_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectAsset',
					on: 'bottom-start',
				},
			},
			{
				id: 'selectWay',
				title: this.$t('tutorial.deposit.step2_title'),
				text: this.$t('tutorial.deposit.step2_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectWay',
					on: 'bottom-start',
				},
			},
			{
				id: 'selectWay',
				title: this.$t('tutorial.deposit.step3_title'),
				text: this.$t('tutorial.deposit.step3_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectWay',
					on: 'bottom-start',
				},
			},
			{
				id: 'selectWay',
				title: this.$t('tutorial.deposit.step4_title'),
				text: this.$t('tutorial.deposit.step4_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectWay',
					on: 'bottom-start',
				},
			},
			{
				id: 'selectWay',
				title: this.$t('tutorial.deposit.step5_title'),
				text: this.$t('tutorial.deposit.step5_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#selectWay',
					on: 'bottom-start',
				},
			},
		],
		'pay-exchange': [
			// 환전하기
			{
				id: 'buySell',
				title: this.$t('tutorial.exchange.step1_title'),
				text: this.$t('tutorial.exchange.step1_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#buySell',
					on: 'bottom',
				},
			},
		],
		'pay-c2c': [
			// c2c
			{
				id: 'regist',
				title: this.$t('tutorial.c2c.step1_title'),
				text: this.$t('tutorial.c2c.step1_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#regist',
					on: 'bottom-end',
				},
			},
			{
				id: 'refresh',
				title: this.$t('tutorial.c2c.step2_title'),
				text: this.$t('tutorial.c2c.step2_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#refresh',
					on: 'bottom',
				},
			},
			{
				id: 'purchaseRequest',
				title: this.$t('tutorial.c2c.step3_title'),
				text: this.$t('tutorial.c2c.step3_text'),
				popperOptions: {
					modifiers: [{ name: 'offset', options: { offset: [0, 16] } }],
				},
				attachTo: {
					element: '#purchaseRequest',
					on: 'bottom-end',
				},
			},
		],
	};
}
